import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      width: _vm.options.width,
      "max-width": _vm.options.maxWidth
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      },
      "click:outside": _vm.cancel
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c(VToolbar, {
    attrs: {
      color: _vm.options.color,
      dense: "",
      flat: ""
    }
  }, [_c(VToolbarTitle, {
    staticClass: "dialog-title"
  }, [_vm._v(_vm._s(_vm.title))])], 1), _c(VCardText, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.message && !_vm.options.isHtmlMessage,
      expression: "!!message && !options.isHtmlMessage"
    }],
    staticClass: "pa-4 dialog-message"
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]), _c(VCardText, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.message && _vm.options.isHtmlMessage,
      expression: "!!message && options.isHtmlMessage"
    }],
    staticClass: "pa-4 dialog-message"
  }, [_c("div", {
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.message))
    }
  })]), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      "data-cy": "confirm-dialog-cancel-btn"
    },
    nativeOn: {
      click: function click($event) {
        return _vm.cancel.apply(null, arguments);
      }
    }
  }, [_vm._v(" No ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      "data-cy": "confirm-dialog-agree-btn"
    },
    nativeOn: {
      click: function click($event) {
        return _vm.agree.apply(null, arguments);
      }
    }
  }, [_vm._v(" Yes ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };